import { LIMITS } from "@/commands/answers/collect-answers-constants";
import { CliError } from "@/lib/cli/cli-error";

export function validateFreeText(
  value: string | undefined,
  label: string,
): void {
  if (value === undefined) {
    return;
  }
  const freeText = value.trim();
  if (freeText.length === 0) {
    throw new CliError(`${label} has empty free text.`, 2);
  }
  if (freeText.length > LIMITS.FREE_TEXT) {
    throw new CliError(
      `${label} has free text longer than ${LIMITS.FREE_TEXT} characters.`,
      2,
    );
  }
}
